import { makeAutoObservable } from 'mobx'
import { appName } from '../Service/http'

export type StudentType = {
	id_protocols: number
	id_teacher: number
	fio: string
	t_fio: string
	osnovanie: string
	id_group: number
	p20: string
	p22: string
	id_a_year: number
	id_f_educ: number
	id_faculty: number
	id_rate: number
	id_leave: number
	reference_number: string
	okno_document: string
	AVN_operator: string
	id_okno_document: number
	id_okno_zakaz: number
	id_raion: number
	ispolnitel: string
	years: string
	naznachenie: string
	id_working:number
	// status_new:number
}

class Teacher {
	teacher: StudentType = {
		id_protocols: 0,
		id_teacher: 0,
		fio: '',
		t_fio: '',
		osnovanie: '',
		id_group: 0,
		p20: '',
		p22: '',
		id_a_year: 0,
		id_f_educ: 0,
		id_faculty: 0,
		id_rate: 0,
		id_leave: 0,
		reference_number: '',
		okno_document: '',
		AVN_operator: '',
		id_okno_document: 0,
		id_okno_zakaz: 0,
		id_raion: 0,
		ispolnitel: '',
		years: '',
		naznachenie: '',
		id_working:0
	}
	photo: string = `${appName}/img/user.png`
	teachers: StudentType[] = []

	constructor() {
		makeAutoObservable(this)
	}

	newTeachers(param: StudentType[]) {
		this.teachers = param
	}
	newTeacher(param: StudentType) {
		this.teacher = param
	}
	newPhoto(param: string) {
		this.photo = param
	}
}

export const teacher = new Teacher()
